import KogModalSideComponent from "@/main/components/modal/ModalSide";
import Button from "@/main/components/shared/button/button";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { QuoteGetItemsResponse } from "@/main/models/response";
import { getTranslateByKey } from "@/main/services/utils";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as S from "./styles";
import { SupplierPartsSelector } from "./supplierPartsSelector";

export interface IApprovalPartsForm {
	quoteSupplierItemGuids: string[];
}

interface IApprovePartsModal {
	isOpen: boolean;
	onClose: () => void;
	data: QuoteGetItemsResponse[];
	showPrices: boolean;
	onSubmitAction: (data: IApprovalPartsForm) => Promise<void>;
}

function ApprovePartsModalContent({ onClose, data, showPrices, onSubmitAction }: Readonly<IApprovePartsModal>) {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const methods = useForm<IApprovalPartsForm>({
		defaultValues: { quoteSupplierItemGuids: [] },
	});

	useEffect(() => {
		if (data && data.length > 0) {
			methods.reset({ quoteSupplierItemGuids: [] });
		}
	}, [data, methods]);

	function submit(formData: IApprovalPartsForm) {
		if (formData.quoteSupplierItemGuids.length === 0) {
			toast.error(
				getTranslateByKey("information.selectOne", true).replace(
					"{0}",
					getTranslateByKey("information.part").toLowerCase(),
				),
			);
			return;
		}
		setIsLoading(true);
		onSubmitAction(formData).finally(() => {
			setIsLoading(false);
		});
	}

	const selectedGuids = methods.watch("quoteSupplierItemGuids") || [];

	const isDisabled = selectedGuids.length === 0;

	return (
		<FormProvider {...methods}>
			<form noValidate>
				<S.ContainerModal>
					<SupplierPartsSelector data={data} showPrices={showPrices} />
					<S.AreaFooter>
						<S.AreaButtons>
							<SecondaryButton type="button" onClick={onClose}>
								{getTranslateByKey("information.back")}
							</SecondaryButton>
							<Button onClick={methods.handleSubmit(submit)} disabled={isDisabled} loading={isLoading}>
								{getTranslateByKey("information.approve")}
							</Button>
						</S.AreaButtons>
					</S.AreaFooter>
				</S.ContainerModal>
			</form>
		</FormProvider>
	);
}

export default function ApprovePartsModal(props: Readonly<IApprovePartsModal>) {
	return (
		<KogModalSideComponent
			shouldRenderOpen
			title={getTranslateByKey("information.partsApproval")}
			open={props.isOpen}
			closeModal={props.onClose}
		>
			{props.isOpen && <ApprovePartsModalContent {...props} />}
		</KogModalSideComponent>
	);
}
